import { Stack, Avatar, Text } from '@chakra-ui/core'
import moment from 'moment'
import React from 'react'
import { Card } from '../../../components'
import { useMyUserQuery } from '../../../generated/graphql'

const Profile = () => {
  const { data } = useMyUserQuery()
  const user = data?.myUser
  const fullname = `${user?.attributes?.firstName || ''} ${user?.attributes?.lastName || ''}`.trim()
  return (
    <Stack>
      <Stack direction="row">
        <Avatar name={fullname} />

        <Stack spacing={0}>
          <Text fontSize="md" fontWeight="bold">
            {fullname || 'Unknown User'}
          </Text>
          <Text fontSize="xs" color="gray.600">
            Member since {moment(user?.attributes?.createdAt).format('MMMM Do YYYY')}
          </Text>
        </Stack>
      </Stack>
      <Card fontSize="sm" color="gray.600" p={4} mt={2}>
        {user?.attributes?.community?.data?.attributes?.name || 'No team assigned'}
      </Card>
    </Stack>
  )
}

export default Profile
